<template>
<div class="chapter">
<div class="inner_page">
<div id="fm7">
<p class="heading2"><em class="italic"><span class="bold">Contents</span></em></p>
<p class="cont"><a href="#/ch_01#ch_01"><span>WITCH’S HOUSE</span></a></p>
<p class="cont"><span href="#/ch_02#ch_02" title="Link target outside of Sample"><span>THE BAD WEEK AND OLD MISS ASHEMEADE</span></span></p>
<p class="cont"><span href="#/ch_03#ch_03" title="Link target outside of Sample"><span>RIDE A WHITE HORSE</span></span></p>
<p class="cont"><span href="#/ch_04#ch_04" title="Link target outside of Sample"><span>PHINEAS AND PHEBE</span></span></p>
<p class="cont"><span href="#/ch_05#ch_05" title="Link target outside of Sample"><span>A COLLAR FOR SABINA</span></span></p>
<p class="cont"><span href="#/ch_06#ch_06" title="Link target outside of Sample"><span>OCTAGON HOUSE KEEPS CHRISTMAS</span></span></p>
<p class="cont"><span href="#/ch_07#ch_07" title="Link target outside of Sample"><span>CHOLE AND NACKIE</span></span></p>
<p class="cont"><span href="#/ch_08#ch_08" title="Link target outside of Sample"><span>STORM CLOUDS</span></span></p>
<p class="cont"><span href="#/ch_09#ch_09" title="Link target outside of Sample"><span>CHARLES</span></span></p>
<p class="cont"><span href="#/ch_10#ch_10" title="Link target outside of Sample"><span>ONE GOLDEN NEEDLE</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0b4bf0ae